import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Media from 'react-media';
import NavbarContainer from '../containers/NavbarContainer';
import SelectedGameMobileContainer from '../containers/SelectedGameMobileContainer';
import SeasonsListContainer from './lists/SeasonsListContainer';
import UmpiresListContainer from '../containers/UmpiresListContainer';
import MembersListContainer from '../containers/MembersListContainer';
import CoachesListContainer from '../containers/CoachesListContainer';
import PlayersListContainer from '../containers/PlayersListContainer';
import DailySummaryContainer from '../containers/DailySummaryContainer';
import MentorTableContainer from '../containers/MentorTableContainer';
import MentorMenteeCardContainer from '../containers/MentorMenteeCardContainer';
import ProfilePageContainer from '../containers/ProfilePageContainer';
import UmpireCompletedGamesPageContainer from '../containers/UmpireCompletedGamesPageContainer';
import TeamStatusTableContainer from '../containers/TeamStatusTableContainer';
import WheelReportContainer from '../containers/WheelReportContainer';
import YTDSummaryContainer from '../containers/YTDSummaryContainer';
import GamesListContainer from '../containers/GamesListContainer';
import WelcomeContainer from '../containers/WelcomeContainer';
import HomeContainer from '../containers/HomeContainer';
import HomeMobileContainer from '../containers/HomeMobileContainer';
import MyGamesMobileContainer from '../containers/MyGamesMobileContainer';
import SMSMessageContainer from '../containers/SMSMessageContainer'; // Import the SMSMessageContainer
import SeasonsUtil from '../utils/SeasonsUtil';

class Main extends Component {

//const Main = props => {
  componentDidMount(){
    const { userType } = this.props;
    const { getSeasonsByActive, getSeasonsByDisplay } = this.props;

    //If user is Admin, get all Seasons.  Otherwise, get only the Active ones
    if (userType === 'Admin') {
      getSeasonsByDisplay(true);
    } else {
      getSeasonsByActive(true);
    }
  }

  componentDidUpdate(prevProps){
    const { seasons, changeUserSeason,userSeason } = this.props;

    //Initialize to the default season if none selected by the user yet
    if (seasons) {
      if (!userSeason) {
        let initSeasonId = SeasonsUtil.getDefaultSeason(seasons,new Date());
        changeUserSeason(initSeasonId);
      }
    }
  }

  render() {
    const { umpireLevel, userType } = this.props;
    return (
     <div>
        <NavbarContainer />
        <Switch>
          <Route exact path="/mentor-mentees" render={() => <MentorMenteeCardContainer />} />
          <Route exact path="/list/seasons" render={() => <SeasonsListContainer />} />
          <Route exact path="/list/umpires" render={() => <UmpiresListContainer />} />
          <Route exact path="/list/members" render={() => <MembersListContainer />} />
          <Route exact path="/list/coaches" render={() => <CoachesListContainer />} />
          <Route exact path="/list/players" render={() => <PlayersListContainer />} />
          <Route exact path="/list/mentors" render={() => <MentorTableContainer />} />
          <Route exact path="/list/games" render={() => <GamesListContainer />} />
          <Route exact path="/dailySummary" render={() => <DailySummaryContainer />} />
          <Route exact path="/reports/team/status" render={() => <TeamStatusTableContainer />} />
          <Route exact path="/reports/umpire/statistics" render={() => <WheelReportContainer />} />
          <Route exact path="/reports/summary" render={() => <YTDSummaryContainer />} />
          <Route exact path="/profile" render={() => <ProfilePageContainer />} />
          <Route exact path="/umpireCompletedGames" render={() => <UmpireCompletedGamesPageContainer />} />
          <Route exact path="/myGamesSummary" render={() => <ProfilePageContainer />} />
          <Route exact path="/selected-game/:gameId" render={() => <SelectedGameMobileContainer />} />
          <Route exact path="/my-games" render={() => <MyGamesMobileContainer />} />
          <Route exact path="/welcome" render={() => <WelcomeContainer />} />
          {userType === 'Admin' && (
            <Route exact path="/sms-message" render={() => <SMSMessageContainer />} />
          )}
          <Route
            exact path="/"
            render={() => {
              if (userType === 'umpire' && umpireLevel < 1) {
                return <Redirect to={{ pathname: '/welcome' }} />;
              } else {
                return (
                  <Media query="(max-width: 760px)">
                    {matches => (matches ? <HomeMobileContainer /> : <HomeContainer />)}
                  </Media>
                );
              }
            }}
          />
          <Route 
            render={() => {
              return (
                <Media query="(max-width: 760px)">
                  {matches => (matches ? <HomeMobileContainer /> : <HomeContainer />)}
                </Media>
              );
            }} 
          />
        </Switch>
      </div>
    );
  };
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js